import { CreateNoteSliceState } from '@/domains/notes/store/types/createNoteTypes';

const initialCreateNoteSteps = {
  selectEntity: {
    entityId: null,
    entityType: null,
    entityTitle: null,
  },
  addDetails: {
    title: '',
    noteTypeId: null,
    description: '',
    isHighPriority: 0 as const,
    hasReminder: null,
    reminderDateTime: null,
    accountToNotifyId: null,
  },
  selectDocuments: {
    documents: [],
  },
};

export const createNoteInitialState: CreateNoteSliceState = {
  statuses: {
    isLoading: false,
    areDocumentsLoading: false,
  },
  entityDocumentOptions: {},
  createDocumentType: 'auto',
  createNoteSteps: initialCreateNoteSteps,
};
